import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, LifeBuoy } from 'lucide-react';
import { useOnline, useOutboxCounts } from '../offline/index.js';
import { onPushState, pushState } from '../native/push.js';
import Schedule from '../modules/plans/Schedule.jsx';
import { AckReminder } from '../modules/comms/Inbox.jsx';

// Start page. In the app it is the schedule (any day, with the map); Messages
// and Support are bottom tabs. In the office, the way to messages and help. A
// warning shows only when something needs attention (no signal, items that
// couldn't be sent, notifications off); otherwise the top bar's
// "All changes saved" says it all.
export default function Home({ me, shell }) {
  const online = useOnline();
  const { pending, rejected } = useOutboxCounts();
  const [push, setPush] = useState(pushState);
  useEffect(() => onPushState(setPush), []);

  const problem = !online
    ? { tone: 'warn', text: 'No signal. You can keep working; anything you do is sent when you reconnect.' }
    : rejected
      ? { tone: 'bad', text: `${rejected} item${rejected === 1 ? '' : 's'} could not be sent. See Support.` }
      : pending
        ? { tone: 'warn', text: `Sending ${pending} item${pending === 1 ? '' : 's'}…` }
        : null;

  return (
    <div className="stack">
      {(problem || push === 'blocked') && (
        <section className="card">
          {problem && <p className={`notice-line notice-${problem.tone}`} role="status">{problem.text}</p>}
          {push === 'blocked' && (
            <p className="small warn-text">Notifications are off. Allow them for Nano Utilities in your phone settings so you don&apos;t miss messages from the office.</p>
          )}
        </section>
      )}

      <AckReminder />

      {shell === 'field' && me.capabilities.includes('field.use') && <Schedule />}

      {shell !== 'field' && (
      <section className="card home-links">
        <Link to="/messages" className="home-link">
          <MessageSquare size={22} aria-hidden="true" />
          <span><strong>Messages</strong><span className="muted small">Updates from the office</span></span>
        </Link>
        <Link to="/support" className="home-link">
          <LifeBuoy size={22} aria-hidden="true" />
          <span><strong>Support</strong><span className="muted small">Call the office, app details</span></span>
        </Link>
      </section>
      )}
    </div>
  );
}
